import { axiosCashJournalClient } from "./api";
import { MIDDLE_URL } from "./config";

interface MetadataI {
  page: number,
  page_size: number,
  total_items: number,
  total_pages: number
}

export interface IGetRangeNominalData {
  id: number,
  range_code: string,
  range_description: string,
  range_number: number,
  start_range: string,
  end_range: string
}

export interface IGetRangeNominalResponse {
  range: IGetRangeNominalData[],
  metadata: MetadataI,
}

interface GetRangeNominalParamsI {
  search?: string,
  is_distinct?: boolean,
  sort_by?: string,
  sort_type?: string,
  page_number?: number,
  page_size?: number,
}

export interface IPostRangeNominalPayload {
  range_code: string,
  start_range: string,
  end_range: string,
  range_description: string,
  created_by: string
}
export interface IPostResponse {
  responseCode: "Succeed" | "Failed",
  responseMessage: string
}

export interface IPutRangeNominalPayload {
  id: number,
  range_code: string,
  start_range: string,
  end_range: string,
  range_description: string,
  update_by: string
}

export const url = "/v1/range_nominal";

export const getRangeNominal = async (
  payload: GetRangeNominalParamsI,
): Promise<IGetRangeNominalResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "GET",
    params: payload,
  });

  return data;
};

export const postRangeNominal = async (
  payload: IPostRangeNominalPayload,
): Promise<IPostResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "POST",
    data: payload,
  });

  return data;
};

export const getRangeNominalByRangeCode = async (
  rangeCode: string,
): Promise<{ range: IGetRangeNominalData[] }> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/${rangeCode}`,
    method: "GET",
  });

  return data;
};

export const putRangeNominal = async (
  payload: IPutRangeNominalPayload,
): Promise<IPostResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "PUT",
    params: payload,
  });

  return data;
};
export const deleteRangeNominal = async (
  id: number,
): Promise<IPostResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/${id}`,
    method: "DELETE",
  });

  return data;
};
